import { Component, ViewChild } from '@angular/core'
import { ModalContainerComponent } from '../../_common/modal-container/modal-container.component'
import QRCode from 'qrcode'

@Component({
  selector: 'modal-qrcode',
  templateUrl: 'modal-qrcode.component.html',
})
export class ModalQrCodeComponent {
  @ViewChild('modal') public childModal: ModalContainerComponent
  code: string
  qrBase64: string

  public async showChildModal(code?: string): Promise<void> {
    if (code) {
      this.code = code
    }
    await this.generateQrCode()
    this.childModal.showChildModal()
  }

  public hideChildModal(): void {
    this.childModal.hideChildModal()
  }

  async generateQrCode() {
    this.qrBase64 = await QRCode.toDataURL(this.code)
  }
}
